import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="none"><path fill="#CB2630" d="M0 8c0-2.8 0-4.2.545-5.27A5 5 0 0 1 2.73.545C3.8 0 5.2 0 8 0h4c2.8 0 4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C20 3.8 20 5.2 20 8v4c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185C16.2 20 14.8 20 12 20H8c-2.8 0-4.2 0-5.27-.545A5 5 0 0 1 .545 17.27C0 16.2 0 14.8 0 12V8Z" class="icon-box"></path><path fill="#0E1015" d="M2.796 10.215q0-1.096.408-2.091Q3.619 7.12 4.4 6.34q.723-.723 1.59-1.11.866-.386 1.869-.508.265-.029.494-.086.236-.064.444-.157.215-.1.408-.237.2-.143.394-.33.559-.536 1.174-.823.616-.293 1.404-.293.702 0 1.346.265.652.265 1.146.759.38.386.752.759.38.372.76.759.493.501.758 1.139.265.637.265 1.346 0 .401-.078.745-.072.343-.215.659-.136.315-.351.608-.208.287-.473.566-.372.387-.558.802-.187.408-.251.938-.122 1.017-.501 1.877-.38.852-1.11 1.582-.78.78-1.784 1.19-.995.414-2.098.414-1.103 0-2.098-.415-.996-.408-1.776-1.189l-.81-.809-.809-.81q-.358-.364-.637-.808-.28-.444-.473-.931-.186-.487-.286-1.003-.1-.516-.1-1.024Zm.802 0q0 .644.164 1.246.172.594.473 1.117.308.516.73.945.43.43.946.738.523.3 1.117.473.602.164 1.246.164.466 0 .953-.1.386-.079.802-.236.422-.165.752-.394.129-.093.2-.215.079-.129.079-.293 0-.122-.057-.251l-1.468-3.08q-.208-.45-.573-.802-.358-.358-.81-.565L5.06 7.515q-.13-.057-.258-.057-.165 0-.287.078-.121.072-.207.201-.172.258-.308.566-.13.3-.222.623-.086.322-.136.651-.043.33-.043.638Zm8.157 2.764q.121 0 .243-.05.122-.057.2-.158.165-.207.294-.48.13-.279.222-.572.1-.301.165-.602.064-.3.086-.558.122-1.304 1.045-2.242.423-.43.652-.91.23-.48.23-1.088 0-.566-.208-1.06-.208-.494-.573-.86-.366-.365-.86-.572-.487-.215-1.052-.215-.61 0-1.103.23-.494.221-.924.644-.466.45-1.031.716-.559.265-1.21.322-.56.057-1.125.236-.559.172-1.031.495-.272.179-.272.5 0 .173.086.316.093.143.25.222l2.535 1.196q.015 0 .015.007.136.057.279.093.143.036.286.036.23 0 .401-.057.172-.065.316-.165.15-.107.286-.243.136-.144.286-.294.13-.129.201-.3.079-.173.079-.359t-.057-.358q-.05-.18-.05-.365 0-.33.121-.623.129-.294.344-.516.215-.222.501-.344.294-.129.63-.129.33 0 .623.13.294.121.509.336.222.215.344.508.129.294.129.623 0 .33-.13.623-.121.294-.343.516-.215.215-.509.344-.286.129-.615.129-.194 0-.373-.058-.172-.057-.358-.057t-.358.079q-.172.072-.308.2l-.286.287q-.136.129-.237.28-.1.142-.164.314-.058.172-.058.394 0 .315.13.58v.007q.006 0 .006.008l1.203 2.52q.08.158.215.251.144.093.323.093zm-.638-6.531q0 .186.065.344.071.157.193.279.122.122.28.193.157.065.343.065.186 0 .344-.065.165-.071.286-.193.122-.122.186-.28.072-.157.072-.343 0-.18-.072-.337-.064-.164-.186-.286-.121-.122-.286-.186-.158-.072-.344-.072-.186 0-.344.072-.157.064-.279.186-.122.122-.193.286-.065.158-.065.337z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
